import React, { useState } from "react";
import "../assets/Draft.css";
import NavBar from "../Components/NavBar";
import Send from "./Send";

export const Draft = () => {
  const [text, setText] = useState(
    "I’m not sure if you remember me but we were desk buddies in Mrs. Middleton’s 3rd grade class at Bee Meadow Elementary School, New Jersey. You were always so nice to talk to everyday about books and cool facts about animals. I also loved sharing fruit snacks with you! We lost touch after you moved to California, but I will always think fondly upon the good memories we shared. Thank you for being my first real friend in New Jersey. I’m not sure where you are now, but please reach out if you ever receive this letter. "
  );
  const [send, setSend] = useState(false);
  const toggleText = (e) => {
    setText(e.target.value);
  };
  function handleSubmit() {
    setSend(true);
  }

  if (send) {
    return <Send text={text} />;
  } else {
    return (
      <div>
        <NavBar />
        <div className="textcenter">
          <h1>Write a Message!</h1>
        </div>
        <div className="center">
          <div className="row">
            <div className="right space-x-5">
              <label for="myFile" className="button m-2 h-14">
                <h5> Upload an image 📤</h5>
                <input
                  className="button"
                  type="file"
                  id="myFile"
                  name="filename"
                />
              </label>

              <a className="button m-2" href="/Profile">
                Save Draft 📁
              </a>

              <a className="button m-2" onClick={handleSubmit}>
                Send ADrift 🌊
              </a>
            </div>
          </div>
        </div>
        <div className="center">
          <textarea
            className="input"
            placeholder="Dear [old friend] ... "
            rows="50"
            cols="150"
            value={text}
            onChange={toggleText}
          />
        </div>
        <br />
      </div>
    );
  }
};

export default Draft;
